import React, { useState, useRef, useEffect } from "react";

export default function FontPicker({ value, options = [], onChange }) {

  const [open, setOpen] = useState(false);
  const containerRef = useRef();

  const selectedFont = value || "";

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!containerRef.current?.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} style={{ position: "relative" }}>

      {/* Selected Font Display */}
      <div
        style={{
          border: "1px solid #ccc",
          padding: "6px 8px",
          cursor: "pointer",
          background: "#fff",
          fontFamily: selectedFont || "inherit"
        }}
        onClick={() => setOpen(!open)}
      >
        {selectedFont || "Select Font"}
      </div>

      {open && (
        <div
          style={{
            position: "absolute",
            zIndex: 2000,
            background: "#fff",
            border: "1px solid #ccc",
            maxHeight: 220,
            overflowY: "auto",
            width: "100%"
          }}
        >

          {options.map(font => (
            <div
              key={font}
              style={{
                padding: "6px 8px",
                cursor: "pointer",
                fontFamily: font
              }}
              onClick={() => {
                onChange(font);
                setOpen(false);
              }}
            >
              {font}
            </div>
          ))}

        </div>
      )}

    </div>
  );
}
